interface HexToRgbInterface {
  (hex: string): string
}

export const hexToRgb: HexToRgbInterface = (hex) => {
  let hexArr: string[] | null = hex
    .replace(
      /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
      (m, r, g, b) => '#' + r + r + g + g + b + b
    )
    .substring(1)
    .match(/.{2}/g)

  return hexArr !== null ? hexArr.map(x => parseInt(x, 16)).join(', ') : hex
}

interface GroupCSSInterface {
  (arr: string[], style: any): { [property: string]: any } // tslint:disable-line no-any
}

export const groupCSS: GroupCSSInterface = (arr, style) => arr.reduce((a, b) => ({ ...a, [b]: style }), {})



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/helpers/styles.ts